setUserEmailAvailabilityProcessing